<template>
    <div>
        <div class="content EC_width">
            <div class="gl_title_bar marginTop40 marginBottom20" id="aboutus">
                <div class="gl_tb_left">
                    <span class="normaltitle">{{ $route.query.SpecialID == '55' ? '关于项目' : '关于我们' }}</span>
                    <a
                        href="javascript:;"
                        v-for="(item, index) in aboutusnaviga"
                        :key="index"
                        :class="{ gl_pad_btn_active: aboutCurIndex == index }"
                        @click="aboutTag(index)"
                        class="gl_pad_btn marginLeft10"
                        >{{ item.title }}</a
                    >
                    <!-- <a href="javascript:;" :class="{gl_pad_btn_active:aboutCurIndex==1}" @click="aboutTag(1)" class="gl_pad_btn marginLeft10">组织机构</a>
                    <a href="javascript:;" :class="{gl_pad_btn_active:aboutCurIndex==2}" @click="aboutTag(2)" class="gl_pad_btn marginLeft10">学术专家</a> -->
                </div>
                <div class="gl_tb_right">
                    <!-- <a href="javascript:;" class="gl_tb_right_more"><img src="/image/index/moreimg.png" class="gltb_moreimg">更多</a> -->
                </div>
            </div>
            <div v-if="aboutCurIndex == 0">
                <div class="display_between">
                    <!-- <img :src="apiData.about0.img"> -->
                    <img :src="aboutusinfo.image" width="401" height="247" style="border-radius: 20px 0 0 0" />
                    <div class="flex1 marginLeft40">
                        <p class="fontBold fontsize18">{{ aboutusinfo.title }}</p>
                        <p class="marginTop20" style="line-height: 28px">{{ aboutusinfo.contents }}</p>
                    </div>
                </div>
            </div>
            <div v-if="aboutCurIndex == 1">
                <div class="display_flex marginBottom10" v-if="aboutusorga.length > 0">
                    <div class="blockTou">{{ aboutusorga }}<img src="/image/qiye/youjiao.png" class="marginLeft10" /></div>
                    <div class="blockNormal marginLeft20" v-for="(item, index) in aboutusorglista" :key="index">
                        <span v-if="item.image"><img :src="item.image" class="img cur" alt="" width="240" height="66" /></span>

                        <span v-else>{{ item.title }}</span>
                    </div>
                </div>
                <div class="display_flex marginBottom10" v-if="aboutusorgb.length > 0">
                    <div class="blockTou">{{ aboutusorgb }}<img src="/image/qiye/youjiao.png" class="marginLeft10" /></div>
                    <div class="blockNormal marginLeft20" v-for="(item, index) in aboutusorglistb" :key="index">
                        <span v-if="item.image"><img :src="item.image" class="img cur" alt="" width="240" height="66" /></span>

                        <span v-else>{{ item.title }}</span>
                    </div>
                </div>
                <div class="display_flex marginBottom10" v-if="aboutusorgc.length > 0">
                    <div class="blockTou">{{ aboutusorgc }}<img src="/image/qiye/youjiao.png" class="marginLeft10" /></div>
                    <div class="blockNormal marginLeft20" v-for="(item, index) in aboutusorglistc" :key="index">
                        <span v-if="item.image"><img :src="item.image" class="img cur" alt="" width="240" height="66" /></span>

                        <span v-else>{{ item.title }}</span>
                    </div>
                </div>
                <div class="display_flex marginBottom10" v-if="aboutusorgd.length > 0">
                    <div class="blockTou">{{ aboutusorgd }}<img src="/image/qiye/youjiao.png" class="marginLeft10" /></div>
                    <div class="blockNormal marginLeft20" v-for="(item, index) in aboutusorglistd" :key="index">
                        <span v-if="item.image"><img :src="item.image" class="img cur" alt="" width="240" height="66" /></span>

                        <span v-else>{{ item.title }}</span>
                    </div>
                </div>
                <div class="display_flex marginBottom10" v-if="aboutusorge.length > 0">
                    <div class="blockTou">{{ aboutusorge }}<img src="/image/qiye/youjiao.png" class="marginLeft10" /></div>
                    <div class="blockNormal marginLeft20" v-for="(item, index) in aboutusorgliste" :key="index">
                        <span v-if="item.image"><img :src="item.image" class="img cur" alt="" width="240" height="66" /></span>

                        <span v-else>{{ item.title }}</span>
                    </div>
                </div>
            </div>
            <div v-if="aboutCurIndex == 2 && this.$route.query.SpecialID == 55 && OneInfo != null">
                <div class="display_center marginBottom20">
                    <div class="blocktou2 display_flex display_center_ud">
                        <img :src="OneInfo.image" width="94" height="94" />
                        <div class="marginLeft30">
                            <p class="fontsize20 fontBold marginBottom10">{{ OneInfo.author }}</p>
                            <p style="padding-right: 20px">{{ OneInfo.contents }}</p>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="aboutCurIndex == 2">
                <div class="display_between marginBottom20" v-for="(item, index) in aboutlist" :key="'0' + index" :class="item.length < 3 ? 'prohibit' : ''">
                    <div class="blocktou2 display_flex display_center_ud" v-for="(itemn, indexn) in item" :key="'0' + index + indexn">
                        <img :src="itemn.image" width="94" height="94" />
                        <div class="marginLeft30">
                            <p class="fontsize20 fontBold marginBottom10">{{ itemn.author }}</p>
                            <p style="padding-right: 20px">{{ itemn.contents }}</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="gl_title_bar marginTop40 marginBottom20" id="dynamics">
                <div class="gl_tb_left">
                    <span class="normaltitle">项目动态</span>
                    <span class="grayColor marginLeft20">{{ aboutusinfo.title }}</span>
                </div>
                <div class="gl_tb_right" @click="navigation(2)">
                    <a href="javascript:;" class="gl_tb_right_more"><img src="/image/index/moreimg.png" class="gltb_moreimg" />更多</a>
                </div>
            </div>
            <div class="display_flex">
                <div class="leftText">
                    <swiper :options="swiperOption3" ref="mySwiper_info" v-if="prodynatextlist.length">
                        <swiper-slide v-for="(item, index) in prodynatextlist" :key="index">
                            <div class="introduct" @click="proDynamLink(item)">
                                <div class="introTitle">
                                    {{ item.title }}
                                </div>
                                <div class="introText" v-html="item.contents">
                                    <!-- {{ ellipsis(item.contents, 230) }} -->
                                </div>
                                <div class="moreintro">查看详情</div>
                            </div>
                        </swiper-slide>
                        <div class="swiper-pagination fiexdrig" slot="pagination"></div>
                    </swiper>
                </div>
                <div class="flex1 display_center_ud">
                    <!-- <img src="/image/qiye/youceimg.png"> -->
                    <img :src="projectimg" width="547" height="302" />
                </div>
            </div>
            <div class="gl_title_bar marginTop40 marginBottom20" v-show="wonderaudiolist.length > 0" id="audiovisual">
                <div class="gl_tb_left">
                    <span class="normaltitle" style="cursor: pointer" @click="activeTag(-1, -1)">{{ wonderName }}</span>
                    <a
                        href="javascript:;"
                        v-for="(item, indexy) in auditionCategoryList"
                        :key="indexy"
                        :class="{ gl_pad_btn_activetype: activeCurIndex == indexy }"
                        @click="activeTag(indexy, item.id)"
                        class="gl_pad_btn marginLeft10"
                        >{{ item.categoryName }}</a
                    >
                </div>
                <div class="gl_tb_right" @click="navigation(3)">
                    <a href="javascript:;" class="gl_tb_right_more"><img src="/image/index/moreimg.png" class="gltb_moreimg" />更多</a>
                </div>
            </div>
            <div class="display_between_audio marginBottom20" v-show="wonderaudiolist.length > 0">
                <div
                    class="st_block"
                    v-for="(item, index) in activeCtyId > -1 ? wonderaudiolist.filter(vitem => vitem.dataOrganizationType == activeCtyId).slice(0, 4) : wonderaudiolist.slice(0, 4)"
                    :key="index"
                >
                    <img :src="item.image" width="280" height="158" />
                    <p style="padding: 0 20px; height: 33px" class="marginBottom20">
                        {{ ellipsis(item.title, 20) }}
                    </p>
                    <div class="audioText">
                        <p v-if="item.contents != ''" :title="item.contents">{{ ellipsis(item.contents, 33) }}</p>
                    </div>
                    <div style="padding: 0 20px" class="display_between">
                        <span style="color: #919ca3" ><img src="/image/qiye/huatong.png" class="marginRight10" />{{ ellipsis(item.author,9) }}</span>
                        <span class="seeVideo" @click="openVideo(item.title)">观看视频</span>
                    </div>
                </div>
                <div
                    v-if="(activeCtyId > -1 ? wonderaudiolist.filter(vitem => vitem.dataOrganizationType == activeCtyId).slice(0, 4) : wonderaudiolist.slice(0, 4)).length == 0"
                    style="text-align: center; width: 100%; line-height: 100px"
                >
                    <strong>暂无数据</strong>
                </div>
            </div>

            <div v-if="activeenvirolist.length != 0">
                <div class="gl_title_bar marginTop40 marginBottom20" id="activity">
                    <div class="gl_tb_left">
                        <span class="normaltitle">{{ activeName }}</span>
                        <span class="grayColor marginLeft20">{{ aboutusinfo.title }}</span>
                    </div>
                    <div class="gl_tb_right">
                        <!-- <a href="javascript:;" class="gl_tb_right_more"><img src="/image/index/moreimg.png" class="gltb_moreimg">更多</a> -->
                    </div>
                </div>
                <div class="positionBtn EC_width">
                    <swiper :options="swiperOption2" ref="mySwiper">
                        <swiper-slide v-for="(item, index) in activeenvirolist" :key="index">
                            <a href="javascript:;">
                                <img :src="item.image" width="382" height="226" />
                            </a>
                        </swiper-slide>
                    </swiper>
                    <div class="prevbutton">&lt;</div>
                    <div class="nextbutton">&gt;</div>
                </div>
            </div>
            <div v-else id="activity"></div>
        </div>
        <videopage :isVideo="isVideo" :videoInfo="wonderaudiolist" :videoTitle="selTitle" @close="isVideo = false" :videolist="videolist" :video="video" @setOther="setOther"></videopage>

        <el-dialog :visible.sync="dialogVisible">
            <img width="100%" :src="dialogImageUrl" alt="" />
        </el-dialog>
    </div>
</template>

<script>
import lodash from 'lodash';

export default {
    name: 'home',
    data() {
        return {
            isVideo: false,
            videolist: [],
            video: {
                title: '对2型糖尿病患者进行个体化的强化药物治疗（上）',
                author: '张文瀚 / 北京大学第三医院 / 主任医师',
                time: '90:50',
                src: '',
            },
            videoTitle: '',
            projectimg: '',
            // 关于我们切换index
            aboutCurIndex: '0',
            //精彩视听分类
            activeCurIndex: '-1',
            aboutlist: [],
            OneInfo: null,
            apiData: {
                about: {},
                dynamic: {},
                visual: {},
                activity: {},
            },
            swiperOption1: {
                loop: true, // 循环模式选项
                // 如果需要分页器
                pagination: {
                    el: '.swiper-pagination',
                    bulletClass: 'bulletWrite',
                    bulletActiveClass: 'bulletWriteActive',
                },
            },
            swiperOption2: {
                slidesPerView: 3,
                slidesPerGroup: 1,
                // 如果需要前进后退按钮
                navigation: {
                    nextEl: '.nextbutton',
                    prevEl: '.prevbutton',
                    disabledClass: 'my-button-disabled',
                },
            },
            swiperOption3: {
                preventLinksPropagation: true,
                loop: true, // 循环模式选项
                grabCursor: true,
                // 如果需要分页器
                pagination: {
                    el: '.swiper-pagination',
                    bulletClass: 'stWrite',
                    bulletActiveClass: 'stbulletWriteActive',
                },
                autoplay: {
                    delay: 6000,
                    disableOnInteraction: false,
                },
                on: {
                    slideChangeTransitionEnd: () => {
                        let swp = this.$refs.mySwiper_info.swiper;
                        if (swp != null) {
                            let swpindex = swp.activeIndex;
                            let listindex = this.prodynatextlist.length;
                            let index = 0;
                            if (swpindex > listindex) {
                                index = 0;
                            } else if (swpindex == 0) {
                                index = listindex - 1;
                            } else {
                                index = swp.activeIndex - 1;
                            }

                            this.projectimg = this.prodynatextlist[index].image;
                        } else {
                            if (this.prodynatextlist.length > 0) {
                                this.projectimg = this.prodynatextlist[0].image;
                            }
                        }
                    },
                },
            },
            /**tianlianpei */
            // 关于我们导航
            aboutusnaviga: [],
            abouts: 0,
            // 关于我们项目介绍
            aboutusinfo: {},
            // 关于我们组织机构
            aboutusorglista: [],
            aboutusorglistb: [],
            aboutusorglistc: [],
            aboutusorglistd: [],
            aboutusorgliste: [],
            // 关于我们学术专家
            baoutusexpertlist: [],
            // 项目动态文字轮播
            prodynatextlist: [],
            // 项目动态图片轮播
            prodynaimglist: [
                {
                    img: '../../../static/project/projecta.jpg',
                },
            ],
            // 精彩视听
            wonderaudiolist: [],
            wonderMenuShow: false,
            wonderName: '精彩视听',
            // 活动掠影
            activeName: '活动掠影',
            activeswiperShow: false,
            activeenvirolista: [],
            activeenvirolistb: [],
            activeenvirolistc: [],
            activeenvirolistaone: [],
            activeenvirolistatwo: [],
            activeenvirolistathree: [],
            activeenvirolist: [],

            // 所有数据
            SpecialProject: [],
            // 颜色集合
            colorSet: [],
            // 活动掠影轮播
            activConSwiper: [],
            wonderaudiomorelist: [],
            selTitle: '',
            showvideo: '',
            aboutusorga: '',
            aboutusorgb: '',
            aboutusorgc: '',
            aboutusorgd: '',
            aboutusorge: '',
            aboutusorgtitle: '',
            itemCount: 0,
            auditionCategoryList: [],
            activeCtyId: -1,
            dialogImageUrl: '',
            dialogVisible: false,
            disabled: false,
            input: '',
            options: [
                {
                    value: '选项1',
                    label: '黄金糕',
                },
                {
                    value: '选项2',
                    label: '双皮奶',
                },
                {
                    value: '选项3',
                    label: '蚵仔煎',
                },
                {
                    value: '选项4',
                    label: '龙须面',
                },
            ],
            value: '',
        };
    },
    created() {
        this.GetSpecialProject();
        this.GetSelectDataItemByID();
        this.GetAuditionCategory();
        this.toggleDialog(true);
    },
    methods: {
        toggleDialog(show) {
            var animationClass = show ? 'slipUp' : 'slipBottom';
            var animation = function () {
                var ele = document.getElementById('dialog-face');
                ele.className = 'dialog-face ' + animationClass;
                ele = document.getElementById('dialog');
                ele.className = 'dialog-root ' + animationClass;
                ele = document.getElementById('dialog-wrapper');
                ele.className = 'dialog-wrapper ' + animationClass;
            };

            setTimeout(animation, 100);
        },
        // 查看图片
        handlePictureCardPreview(file) {
            this.dialogImageUrl = file.url;
            this.dialogVisible = true;
        },
        setOther() {},
        openVideo(title) {
            this.videolist = [];
            this.selTitle = title;
            this.videolist = this.wonderaudiomorelist.filter(item => item.colors == title);
            this.isVideo = true;
        },
        getData() {
            var that = this;
            fetch('/data.json')
                .then(res => {
                    return res.json();
                })
                .then(data => {
                    that.apiData = data.qyhome.data;
                });
        },
        aboutTag(index) {
            // 根据index跟新数据
            this.aboutCurIndex = index;
            this.apiData.about = {};
        },
        //精彩视听分类切换
        activeTag(index, id) {
            // 根据index跟新数据
            this.activeCurIndex = index;
            this.activeCtyId = id;
        },
        /**tianlianpei */
        GetSpecialProject() {
            var arry = [];
            this.httphelper
                .post('/api/SpecialApi/GetGpSiteSpecialDataItemDetailsPageLists', {
                    specialInfoID: Number(this.$route.query.SpecialID),
                    sD_Id: 0,
                })
                .then(res => {
                    this.SpecialProject = res.data.data;
                    this.SpecialProject.forEach(item => {
                        if (item.category == '9' || item.category == '10' || item.category == '11') {
                            // 关于我们tab
                            this.aboutusnaviga.push({
                                title: item.title,
                                category: item.category,
                            });
                        } else if (item.category == '12') {
                            // 项目介绍
                            this.aboutusinfo = item;
                        } else if (item.category == '7') {
                            // 项目动态
                            this.prodynatextlist.push(item);
                        } else if (item.category == '8') {
                            // 精彩视听
                            if (item.sDataItemName != '' && item.sDataItemName != null) {
                                this.wonderName = item.sDataItemName;
                            }
                            if (item.title != '' && item.title != null) {
                                this.wonderaudiolist.push(item);
                            } else {
                                this.wonderaudiomorelist.push(item);
                            }
                        } else if (item.category == '6') {
                            // 颜色设置
                            this.colorSet = JSON.parse(item.contents);
                        } else if (item.category == '19') {
                            // 活动掠影
                            this.activeenvirolist.push(item);
                            this.activeenvirolista.push(item);
                            if (item.author != 'TPJ1') {
                                this.activeenvirolistaone.push(item);
                            }
                        } else if (item.category == '20') {
                            // 活动掠影
                            this.activeenvirolist.push(item);
                            this.activeenvirolistb.push(item);

                            if (item.author != 'TPJ2') {
                                this.activeenvirolistatwo.push(item);
                            }
                        } else if (item.category == '21') {
                            // 活动掠影
                            this.activeenvirolist.push(item);
                            this.activeenvirolistc.push(item);
                            if (item.author != 'TPJ3') {
                                this.activeenvirolistathree.push(item);
                            }
                        } else if (item.category == '18') {
                            // 活动掠影
                            if (item.sDataItemName != '' && item.sDataItemName != null) {
                                this.activeName = item.sDataItemName;
                            }
                        } else if (item.category == '13') {
                            // 组织机构-1

                            this.aboutusorglista.push(item);
                            arry = this.aboutusorglista[0].sDataItemName.split('-');
                            if (arry.length > 1) {
                                this.aboutusorga = arry[1];
                                this.aboutusorgtitle = arry[0];
                            }
                        } else if (item.category == '14') {
                            // 组织机构-2
                            this.aboutusorglistb.push(item);
                            arry = this.aboutusorglistb[0].sDataItemName.split('-');
                            if (arry.length > 1) {
                                this.aboutusorgb = arry[1];
                                this.aboutusorgtitle = arry[0];
                            }
                        } else if (item.category == '15') {
                            // 组织机构-3
                            this.aboutusorglistc.push(item);
                            arry = this.aboutusorglistc[0].sDataItemName.split('-');
                            if (arry.length > 1) {
                                this.aboutusorgc = arry[1];
                                this.aboutusorgtitle = arry[0];
                            }
                        } else if (item.category == '16') {
                            // 组织机构-4
                            this.aboutusorglistd.push(item);
                            arry = this.aboutusorglistd[0].sDataItemName.split('-');
                            if (arry.length > 1) {
                                this.aboutusorgd = arry[1];
                                this.aboutusorgtitle = arry[0];
                            }
                        } else if (item.category == '22') {
                            // 组织机构-5
                            this.aboutusorgliste.push(item);
                            arry = this.aboutusorgliste[0].sDataItemName.split('-');
                            if (arry.length > 1) {
                                this.aboutusorge = arry[1];
                                this.aboutusorgtitle = arry[0];
                            }
                        } else if (item.category == '17') {
                            // 评审专家
                            this.baoutusexpertlist.push(item);
                        }
                    });
                    if (this.$route.query.SpecialID == 55 && this.baoutusexpertlist.length > 0) {
                        this.OneInfo = this.baoutusexpertlist[0];
                        this.baoutusexpertlist.shift();
                    }
                    this.wonderaudiolist = this.wonderaudiolist.sort((a, b) => {
                        return b.id - a.id;
                    });
                    this.aboutlist = lodash.chunk(this.baoutusexpertlist, 3);
                    this.aboutusnaviga = this.uniquetitle(this.aboutusnaviga);
                    this.aboutusnaviga.sort(this.compare('category'));
                    this.activeenvirolistc = this.unique(this.activeenvirolistc);
                    this.activeenvirolista = this.unique(this.activeenvirolista);
                });
        },
        unique(arr) {
            const res = new Map();
            return arr.filter(arr => !res.has(arr.id) && res.set(arr.id, 1));
        },
        uniquetitle(arr) {
            const res = new Map();
            return arr.filter(arr => !res.has(arr.title) && res.set(arr.title, 1));
        },
        compare(attr) {
            return function (a, b) {
                var val1 = a[attr];
                var val2 = b[attr];
                return val1 - val2;
            };
        },
        navigation(index) {
            if (index == 2) {
                this.$router.push({
                    path: '/enterprise/enterpriseList',
                    query: {
                        SpecialID: Number(this.$route.query.SpecialID),
                    },
                });
            } else if (index == 3) {
                this.$router.push({
                    path: '/enterprise/enterpriseList2',
                    query: {
                        SpecialID: Number(this.$route.query.SpecialID),
                    },
                });
            }
        },
        //关于我们点击事件
        clkabout(item, index) {
            this.abouts = index;
        },
        GetSelectDataItemByID() {
            this.httphelper
                .post('/api/SpecialApi/GetSelectDataItemByID', {
                    ID: Number(this.$route.query.SpecialID),
                })
                .then(res => {
                    if (res.data.code == 200) {
                        this.itemCount = res.data.data[0].count;
                    }
                });
        },
        //获取精彩视听分类数据
        GetAuditionCategory() {
            this.httphelper
                .post('/api/SpecialApi/GetAuditionCategory', {
                    ID: Number(this.$route.query.SpecialID),
                })
                .then(res => {
                    if (res.data.code == 200) {
                        this.auditionCategoryList = res.data.data;
                    }
                });
        },
        proDynamLink(info) {
            let urlstr = info.address;
            let param = urlstr.substr(urlstr.indexOf('?'), urlstr.length - urlstr.indexOf('?'));
            if (urlstr.search('specialRecomme') > -1) {
                const { href } = this.$router.resolve({
                    path: '/home/specialRecomme?',
                    query: {
                        SpecialID: this.$route.query.SpecialID,
                        id: info.id,
                    },
                });
                window.open(href, '_blank');
            } else if (urlstr.search('specialproject/projectdetail') > -1) {
                const { href } = this.$router.resolve({
                    path: '/enterprise/enterpriseDetail?' + param,
                });
                window.open(href, '_blank');
            } else {
                window.open(info.address, '_blank');
            }
        },
    },
};
</script>

<style scoped>
.display_between_audio {
    display: flex;
    align-items: center;
}
.prohibit::after {
    content: '';
    width: 387px;
}
/* 轮播 */
.bulletWrite {
    margin-right: 6px;
    display: inline-block;
    width: 10px;
    height: 10px;
    background: #6c9ca3;
    border-radius: 50%;
}

.bulletWriteActive {
    width: 24px;
    height: 10px;
    background: #ffffff;
    border-radius: 4px;
    opacity: 1;
}

.my-bullet-active {
    background: #ff6600;
    opacity: 1;
}

.swiper-pagination {
    text-align: right;
    box-sizing: border-box;
    padding-left: 20px;
    padding-right: 360px;
    bottom: 22px;
}

.bannerBgWrap {
    height: 400px;
    background: url(/image/qiye/qy_bg.png) center no-repeat;
    background-size: 100%;
}

.btnbanner {
    display: inline-block;
    width: 300px;
    height: 40px;
    background: #d20028;
    border-radius: 20px;
    font-size: 18px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #ffffff;
    text-align: center;
    line-height: 40px;
    cursor: pointer;
    margin-top: 306px;
}

/* 轮播按钮 */
.nextbutton,
.prevbutton,
.nextbutton2,
.prevbutton2 {
    display: inline-block;
    width: 30px;
    height: 30px;
    text-align: center;
    line-height: 30px;
    box-sizing: border-box;
    border-radius: 30px;
    background: #0b8586;
    color: #fff;
    position: absolute;
    top: 42%;
    z-index: 10;
    cursor: pointer;
    outline: none;
}

.nextbutton,
.nextbutton2 {
    right: -30px;
    left: auto;
}

.prevbutton,
.prevbutton2 {
    right: auto;
    left: -30px;
}

.my-button-disabled {
    background: #ddd;
    color: #999;
}

/* 面包屑导航 */
.breadcrumb_wrap {
    min-width: 1300px;
    list-style: none;
    height: 40px;
    background: #f2f2f2;
    display: flex;
}

.set_breadcrumb {
    list-style: none;
    line-height: 40px;
    height: 100%;
    padding: 0;
}

.set_breadcrumb li {
    display: inline-block;
    font-size: 12px;
    color: #0b8485;
}

.set_breadcrumb li ~ li:before {
    content: '>';
    margin-left: 4px;
    margin-right: 4px;
    color: #333;
}

.set_breadcrumb li a {
    display: inline-block;
    font-size: 12px;
    color: #333;
}

.breadcrumb_search input {
    width: 200px;
    height: 30px;
    box-sizing: border-box;
    border-top-left-radius: 30px;
    border-bottom-left-radius: 30px;
    outline: none;
    border: 1px solid #f2f2f2;
    padding-left: 10px;
}

.ArrIcon {
    display: inline-block;
    width: 50px;
    height: 30px;
    background: #0b8686;
    border-radius: 0 30px 30px 0;
    text-align: center;
    line-height: 30px;
    cursor: pointer;
}

.content {
    flex: 1;
    padding-bottom: 80px;
}

.blockTou {
    width: 192px;
    height: 66px;
    background: #0b8586;
    font-size: 18px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #ffffff;
    text-align: center;
    line-height: 66px;
}
.blocktou2 {
    width: 387px;
    height: 124px;
    border: 1px solid #e5e5e5;
}
.blocktou2 img {
    margin-left: 18px;
}
.blockNormal {
    width: 240px;
    height: 66px;
    border: 1px solid #e5e5e5;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #000000;
    text-align: center;
    line-height: 66px;
}

.leftText {
    width: 560px;
    margin-right: 46px;
    padding-top: 20px;
    padding-bottom: 20px;
}

.introTitle {
    font-size: 18px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #000000;
    margin-bottom: 20px;
}

.introText {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #000000;
    line-height: 28px;
    text-align: justify;
    height: 189px;
    overflow: hidden;
}
.audioText {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    padding: 0 20px 10px 0;
    color: #404040;
    line-height: 28px;
    text-align: justify;
    height: 50px;
    overflow: hidden;
    margin: 0 15px;
}
.moreintro {
    width: 162px;
    height: 40px;
    background: #0b8586;
    border-radius: 20px;
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #ffffff;
    line-height: 40px;
    text-align: center;
    cursor: pointer;
    margin-top: 40px;
}

.fiexdrig {
    text-align: right;
    padding-right: 20px;
}

.stWrite {
    display: inline-block;
    width: 13px;
    height: 13px;
    background: #d3d3d3;
    border-radius: 50%;
    margin-right: 12px;
}

.stbulletWriteActive {
    display: inline-block;
    width: 34px;
    height: 13px;
    background: #0b8586;
    border-radius: 6px;
}

.st_block {
    margin-left: 40px;
    width: 280px;
    padding-bottom: 19px;
    background: #ffffff;
    border-radius: 0px 0px 5px 5px;
    box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.04);
}

.seeVideo {
    display: inline-block;
    width: 110px;
    height: 30px;
    border: 1px solid #0b8586;
    border-radius: 15px;
    text-align: center;
    line-height: 30px;
    color: #0b8586;
    cursor: pointer;
}

.seeVideo:hover {
    color: #ffffff;
    background: #0b8586;
}

.positionBtn {
    margin-top: 20px;
    position: relative;
    width: 1240px;
}

.swiper-slide {
    text-align: center;
}
a,
button {
    outline: none;
}

button {
    border: none;
    padding: 0.6em 1.2em;
    background: #175c9c;
    color: #fff;
    font-size: 1em;
    cursor: pointer;
    display: block;
    margin: 3px auto;
    border-radius: 2px;
}

button:hover,
button:active,
button:focus {
    border: none;
}

/* ---------------------弹窗样式 -------------------*/
.dialog-face {
    position: fixed;
    background: #000;
    height: 100%;
    width: 100%;
    z-index: 9;
    top: 0;
    left: 0;
    opacity: 0.3;
    display: none;
    -webkit-animation-duration: 500ms;
    -moz-animation-duration: 500ms;
    -o-animation-duration: 500ms;
    animation-duration: 500ms;
}

.dialog-face.slipBottom[opacity='0'] {
    display: none;
}

.dialog-face.slipUp {
    opacity: 0.7;
    -webkit-animation-name: dialogFaceSlipToUp;
    -moz-animation-name: dialogFaceSlipToUp;
    -o-animation-name: dialogFaceSlipToUp;
    animation-name: dialogFaceSlipToUp;
}

.dialog-face.slipBottom {
    opacity: 0;
    visibility: hidden;
    -webkit-animation-name: dialogFaceSlipToBottom;
    -moz-animation-name: dialogFaceSlipToBottom;
    -o-animation-name: dialogFaceSlipToBottom;
    animation-name: dialogFaceSlipToBottom;
}

.dialog-root {
    position: fixed;
    z-index: 9;
    left: 50%;

    -webkit-animation-duration: 500ms;
    -moz-animation-duration: 500ms;
    -o-animation-duration: 500ms;
    animation-duration: 500ms;
    -webkit-perspective: 1300px;
    -moz-perspective: 1300px;
    perspective: 1300px;
}

.dialog-root.slipUp {
    top: 50%;
    opacity: 1;

    -webkit-animation-name: dialogSlipToUp;
    -moz-animation-name: dialogSlipToUp;
    -o-animation-name: dialogSlipToUp;
    animation-name: dialogSlipToUp;
    -webkit-transform: translate(-50%, -50%);
    -o-transform: translate(-50%, -50%);
    -moz-transform: translate(-50%, -50%);
    -ms-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
}

.dialog-root.slipBottom {
    top: 100%;
    opacity: 0.3;
    -webkit-animation-duration: 500ms;
    -moz-animation-duration: 500ms;
    -o-animation-duration: 500ms;
    animation-duration: 500ms;
    -webkit-animation-name: dialogSlipToBottom;
    -moz-animation-name: dialogSlipToBottom;
    -o-animation-name: dialogSlipToBottom;
    animation-name: dialogSlipToBottom;
    -webkit-transform: translate(-50%, 0);
    -o-transform: translate(-50%, 0);
    -moz-transform: translate(-50%, 0);
    -ms-transform: translate(-50%, 0);
    transform: translate(-50%, 0);
}

.dialog-wrapper {
    background: #fff;
    width: 555px;
    /* height: 375px; */
    padding-bottom: 20px;
    overflow: hidden;
    -webkit-border-radius: 5px;
    -moz-border-radius: 5px;
    border-radius: 5px;

    -webkit-animation-duration: 500ms;
    -moz-animation-duration: 500ms;
    -o-animation-duration: 500ms;
    animation-duration: 500ms;
    -webkit-transform-origin: 50% 100%;
    -moz-transform-origin: 50% 100%;
    -ms-transform-origin: 50% 100%;
    -o-transform-origin: 50% 100%;
    transform-origin: 50% 100%;
    box-shadow: 0 15px 35px rgba(0, 0, 0, 0.1);
    box-shadow: 7px 7px 12px rgba(0, 0, 0, 0.4), -7px -7px 12px rgba(255, 255, 255, 0.9);
}

.dialog-wrapper.slipUp {
    -webkit-transform: rotateX(0deg);
    -moz-transform: rotateX(0deg);
    -ms-transform: rotateX(0deg);
    -o-transform: rotateX(0deg);
    transform: rotateX(0deg);
    -webkit-animation-name: contentSlipToUp;
    -moz-animation-name: contentSlipToUp;
    -o-animation-name: contentSlipToUp;
    animation-name: contentSlipToUp;
}

.dialog-wrapper.slipBottom {
    -webkit-transform: rotateX(90deg);
    -moz-transform: rotateX(90deg);
    -ms-transform: rotateX(90deg);
    -o-transform: rotateX(90deg);
    transform: rotateX(90deg);
    -webkit-animation-name: contentSlipToBottom;
    -moz-animation-name: contentSlipToBottom;
    -o-animation-name: contentSlipToBottom;
    animation-name: contentSlipToBottom;
}

.dialog-header {
    height: 64px;
    background: #175c9c;
    text-align: center;
}

.dialog-header span {
    font-size: 28px;
    line-height: 64px;
    color: #f6cbc6;
}

.dialog-content {
    font-weight: 300;
    font-size: 1.15em;
    color: #333;
    padding: 7px 40px 14px 40px;
    margin: 0;
}

.dialog-content p {
    margin: 0;
    padding: 10px 0;
}

.dialog-footer {
}
/* ---------------------动画关键帧 -------------------*/

@keyframes dialogFaceSlipToUp {
    0% {
        opacity: 0;
    }
    100% {
        opacity: 0.7;
    }
}

@keyframes dialogFaceSlipToBottom {
    0% {
        opacity: 0.7;
        visibility: visible;
    }
    100% {
        visibility: hidden;
        opacity: 0;
    }
}

@keyframes dialogSlipToUp {
    0% {
        top: 100%;
        opacity: 0.3;
    }
    100% {
        top: 50%;
        opacity: 1;
    }
}

@keyframes dialogSlipToBottom {
    0% {
        top: 50%;
        opacity: 1;
        -webkit-transform: translate(-50%, -50%);
        -moz-transform: translate(-50%, -50%);
        -ms-transform: translate(-50%, -50%);
        -o-transform: translate(-50%, -50%);
        transform: translate(-50%, -50%);
    }
    100% {
        top: 100%;
        opacity: 0.3;
        -webkit-transform: translate(-50%, 0);
        -moz-transform: translate(-50%, 0);
        -ms-transform: translate(-50%, 0);
        -o-transform: translate(-50%, 0);
        transform: translate(-50%, 0);
    }
}

@keyframes contentSlipToUp {
    0% {
        -webkit-transform: rotateX(90deg);
        -moz-transform: rotateX(90deg);
        -ms-transform: rotateX(90deg);
        -o-transform: rotateX(90deg);
        transform: rotateX(90deg);
    }
    100% {
        -webkit-transform: rotateX(0deg);
        -moz-transform: rotateX(0deg);
        -ms-transform: rotateX(0deg);
        -o-transform: rotateX(0deg);
        transform: rotateX(0deg);
    }
}

@keyframes contentSlipToBottom {
    0% {
        -webkit-transform: rotateX(0deg);
        -moz-transform: rotateX(0deg);
        -ms-transform: rotateX(0deg);
        -o-transform: rotateX(0deg);
        transform: rotateX(0deg);
    }
    60% {
        -webkit-transform: rotateX(60deg);
        -moz-transform: rotateX(60deg);
        -ms-transform: rotateX(60deg);
        -o-transform: rotateX(60deg);
        transform: rotateX(60deg);
    }
    100% {
        -webkit-transform: rotateX(90deg);
        -moz-transform: rotateX(90deg);
        -ms-transform: rotateX(90deg);
        -o-transform: rotateX(90deg);
        transform: rotateX(90deg);
    }
}
::v-deep .el-upload--picture-card {
    width: 100px !important;
    height: 100px !important;
    line-height: 102px !important;
}
::v-deep .el-upload-list__item {
    width: 100px !important;
    height: 100px !important;
}
.el-select {
    width: 100%;
}
</style>
